export const MICROSITE_PATH = {
  INDEX: '/microsite/post-applicant/',
  EDIT: '/microsite-admin/'
}

export const QUESTIONNAIRE_IMAGE_ACCEPT_FILE_TYPE = [
  'image/png',
  'image/jpeg',
  'image/gif',
  'image/jpg'
]

export const QUESTIONNAIRE_IMAGE_ACCEPT_FILE_SIZE = 5 * 1024 * 1024 // 5MB

export const POST_APPLICANT_DEFAULT_QUESTIONNAIRE_TYPE = [
  {
    i18nKey: 'admin.company.postApplicant.questionnaireType.general',
    value: 'GENERAL'
  }
]
